import { AnalyticsIcon, CaseIcon, InsuranceIcon, MedicalFileIcon } from '@/components/icons';
import { SideBarRouteOption } from '@/types';
import { BiCog } from 'react-icons/bi';
import { FaBuilding, FaKey, FaMoneyCheckDollar, FaPills, FaTicket, FaUsers } from 'react-icons/fa6';
import { GiHealthCapsule, GiWinterGloves } from 'react-icons/gi';
import { IoMdStats } from 'react-icons/io';
import { IoDocumentsOutline } from 'react-icons/io5';
import { MdOutlineBiotech } from 'react-icons/md';

const mohAdminRoutes: SideBarRouteOption[] = [
   {
      name: 'Analytics',
      path: '/moh-admin',
      icon: AnalyticsIcon,
   },
   {
      name: 'History',
      path: '/moh-admin/history',
      icon: MedicalFileIcon,
      hasSubRoutes: true,
      routes: [
         {
            name: 'Eligibility Checks',
            path: '/moh-admin/history/eligibility-checks',
            icon: MedicalFileIcon,
         },
         {
            name: 'Approvals',
            path: '/moh-admin/history/approvals',
            icon: MedicalFileIcon,
         },
         {
            name: 'Claims',
            path: '/moh-admin/history/claims',
            icon: MedicalFileIcon,
         },
         {
            name: 'Billing',
            path: '/moh-admin/history/billing',
            icon: MedicalFileIcon,
         },
      ],
   },
   // {
   //    name: 'Approval Requests',
   //    path: '/moh-admin/approval-requests',
   //    icon: CaseIcon,
   // },
   // {
   //    name: 'Bills',
   //    path: '/moh-admin/bills',
   //    icon: FaMoneyCheckDollar,
   // },
   {
      name: 'Insurances',
      path: '/moh-admin/insurances',
      icon: InsuranceIcon,
   },
   // {
   //    name: 'Medical Items',
   //    path: '/moh-admin/medical-items',
   //    icon: GiHealthCapsule,
   //    hasSubRoutes: true,
   //    routes: [
   //       {
   //          name: 'Overview',
   //          path: '/moh-admin/medical-items',
   //          icon: IoMdStats,
   //       },
   //       {
   //          name: 'Consumables',
   //          path: '/moh-admin/medical-items/consumables',
   //          icon: GiWinterGloves,
   //       },
   //       {
   //          name: 'Medical Acts',
   //          path: '/moh-admin/medical-items/medical-acts',
   //          icon: GiHealthCapsule,
   //       },
   //       {
   //          name: 'Drugs',
   //          path: '/moh-admin/medical-items/drugs',
   //          icon: FaPills,
   //       },
   //    ],
   // },
   // {
   //    name: 'Tariff',
   //    path: '/moh-admin/tariffs',
   //    icon: FaMoneyCheckDollar,
   //    hasSubRoutes: true,
   //    routes: [
   //       {
   //          name: 'Overview',
   //          path: '/moh-admin/tariffs',
   //          icon: IoMdStats,
   //       },
   //       {
   //          name: 'Medical Acts',
   //          path: '/moh-admin/tariffs/medical-acts',
   //          icon: GiHealthCapsule,
   //       },
   //       {
   //          name: 'Consumables',
   //          path: '/moh-admin/tariffs/consumables',
   //          icon: GiWinterGloves,
   //       },
   //       {
   //          name: 'Drugs',
   //          path: '/moh-admin/tariffs/drugs',
   //          icon: FaPills,
   //       },
   //    ],
   // },
   // {
   //    name: 'RSSB Mocks',
   //    path: '/moh-admin/rssb-mocks',
   //    icon: FaPills,
   //    hasSubRoutes: true,
   //    routes: [
   //       {
   //          name: 'Practitioners',
   //          path: '/moh-admin/rssb-mocks/practitioners',
   //          icon: FaUsers,
   //       },
   //       {
   //          name: 'Facilities',
   //          path: '/moh-admin/rssb-mocks/facilities',
   //          icon: FaBuilding,
   //       },
   //       {
   //          name: 'Vouchers',
   //          path: '/moh-admin/rssb-mocks/vouchers',
   //          icon: FaTicket,
   //       },
   //       {
   //          name: 'Reports',
   //          path: '/moh-admin/rssb-mocks/reports',
   //          icon: IoDocumentsOutline,
   //       },
   //    ],
   // },
   {
      name: 'Reports',
      path: '/moh-admin/reports',
      icon: IoDocumentsOutline,
   },
   {
      name: 'Test',
      path: '/moh-admin/eligibility-test',
      icon: MdOutlineBiotech,
      hasSubRoutes: true,
      routes: [
         {
            name: 'Eligibility Check',
            path: '/moh-admin/eligibility-test',
            icon: MdOutlineBiotech,
         },
      ],
   },
   {
      name: 'Tokens',
      path: '/moh-admin/tokens',
      icon: FaKey,
   },
   {
      name: 'System Settings',
      path: '/moh-admin/system-settings',
      icon: BiCog,
      hasSubRoutes: true,
      routes: [
         {
            name: 'System Users',
            path: '/moh-admin/system-settings/users',
            icon: FaUsers,
         },
         {
            name: 'System Roles',
            path: '/moh-admin/system-settings/roles',
            icon: BiCog,
         },
      ],
   },
];

export default mohAdminRoutes;
